(function($) {

  $(window).on('bookshelf-alignment', () => {
    $('.bookshelf-alignment-group').each(function() {
      const $this = $(this)
      let max = 0

      $this.find('.bookshelf-alignment-target img').each(function(){
        var img = new Image();
        img.onload = function() {
          max = Math.max(max, img.height / img.width)
          if (max === 0) {
            max = (1.7 / 1)
          }
          $this.find('.bookshelf-alignment-target').css({ paddingBottom: (max * 100) + '%' })
        }
        img.src = $(this).attr('src'); // Trigger onload. Alternatively: https://imagesloaded.desandro.com
      });

      // $this.find('.bookshelf-alignment-target img').each(function() {
      // $this.find('.bookshelf-alignment-target img').on('load', function() {
      //   max = Math.max(max, $(this).height() / $(this).width())
      //   if (max === 0) {
      //     max = (1.7 / 1)
      //   }
      //   $this.find('.bookshelf-alignment-target').css({ paddingBottom: (max * 100) + '%' })
      // })
    })
  })
  $(window).trigger('bookshelf-alignment')

})(jQuery);